import React from 'react'
import PropTypes from 'prop-types'

import { ResourceDetailsBlock } from '../../ProjectDescription.styles'

const Description = ({ year, capacity, lang }) => {
  return (
    <>
      {year && (
        <ResourceDetailsBlock>
          <div className="label">
            {lang === 'en' ? 'Year of operation ' : 'سنة التشغيل'}
          </div>
          <div className="value">{year}</div>
        </ResourceDetailsBlock>
      )}
      {capacity && (
        <ResourceDetailsBlock>
          <span className="label">
            {lang === 'en'
              ? 'Capacity (m³/Hour)'
              : 'القدرة التصميمية (م٣ في الساعة)'}
          </span>
          <span className="value">{capacity}</span>
        </ResourceDetailsBlock>
      )}
    </>
  )
}

Description.propTypes = {
  year: PropTypes.string,
  capacity: PropTypes.string,
  lang: PropTypes.string
}

export default Description
